import React from 'react';
import { Link } from 'react-router-dom';
import datagain_home_page_hero_img from '../../../assets/images/datagain-home-page-hero-img.png';
import logo from '../../../assets/images/logo.svg';
import thankyou from '../../../assets/images/thank-you.jpg';
import { LOGIN_ROUTE } from '../../../constants/RouteNameConstants';

const Success = () => {
  return (
    <div className="d-flex vh-100 w-100 flex-column overflow-y-auto bg-lighter">
      <div className="d-flex flex-grow-1 align-items-center justify-content-center py-4">
        <div className="login-card shadow-sm register-card">
            <div className="form-group text-center mb-3">
              <Link to={LOGIN_ROUTE}>
                <img src={logo} alt="logo" className="img-fluid logo-img" />
              </Link>
            </div>
              <div>
                <div className="form-group">
                  <div className="text-center d-flex justify-content-center mb-3">
                    <div>
                      <img src={thankyou} alt="logo" className="img-fluid w-50" />
                    </div>
                  </div>
                  <h1 className="form-title mt-2 fnt-20 text-center mb-0">Thank you for your interest in Ant Datagain.</h1>
                  <p className="font-weight-normal opacity-50 fnt-14 text-center">
                    We will get back to you shortly regarding our onboarding process.
                  </p>
                </div>
              </div>
            </div>
      </div>
    </div>
  );
};

export default Success;
